// extracted by mini-css-extract-plugin
export default {"overlay":"Loader_overlay__WADyo"};